export const networkResetDeviceConstants = {
    NETWORK_RESET_DEVICE_LIST_REQUEST: "NETWORK_RESET_DEVICE_LIST_REQUEST",
    NETWORK_RESET_DEVICE_LIST_SUCCESS: "NETWORK_RESET_DEVICE_LIST_SUCCESS",
    NETWORK_RESET_DEVICE_LIST_FAILURE: "NETWORK_RESET_DEVICE_LIST_FAILURE",
    NETWORK_RESET_DEVICE_LIST_CLEAR: "NETWORK_RESET_DEVICE_LIST_CLEAR",

    NETWORK_RESET_DEVICE_BY_ID_REQUEST: "NETWORK_RESET_DEVICE_BY_ID_REQUEST",
    NETWORK_RESET_DEVICE_BY_ID_SUCCESS: "NETWORK_RESET_DEVICE_BY_ID_SUCCESS",
    NETWORK_RESET_DEVICE_BY_ID_FAILURE: "NETWORK_RESET_DEVICE_BY_ID_FAILURE"
}
